import 'babel-polyfill'
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.css'
import App from './App'
import router from './router'
import { store } from './store'
import * as VueGoogleMaps from 'vue2-google-maps'
import 'font-awesome/css/font-awesome.css'
import VueCordova from 'vue-cordova'

Vue.use(VueCordova)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAxMdfhyLVqoe8sOv53O2wCZanpIZkk_CQ',
    language: 'fr',
    libraries: 'places,drawing,visualization,geometry'
  }
})

Vue.use(Vuetify)

Vue.config.productionTip = false
Vue.filter('uppercase', function (value) {
  return value.toUpperCase()
})
Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  data: function () {
    return {
      cordova: Vue.cordova
    }
  },
  created () {
  }
})

if (window.location.protocol === 'file:' || window.location.port === '3000') {
  var cordovaScript = document.createElement('script')
  cordovaScript.setAttribute('type', 'text/javascript')
  cordovaScript.setAttribute('src', 'cordova.js')
  document.body.appendChild(cordovaScript)
}



// WEBPACK FOOTER //
// ./src/main.js